
import { useTranslation } from "react-i18next";

const MinimumOrderAmountPopup = ({popupClose, minmumAmount})=>{
  const { t } = useTranslation(); // Used Translation file
  return (
    <div className="custom-alert-pop common_alert_popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>{t('minimum_cart_head_txt')}</h4>
                </div>
                <div className="custom-alert-body">
                  <p>{minmumAmount}</p>

                  <div className="alert-buttons">
                    <a
                      className="popup-alert-btn button"
                      onClick={(e)=>popupClose(false)}
                    >
                      {t('ok_btntxt')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          );
}

export default MinimumOrderAmountPopup;
